import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

export default function MultiFileUploadForm({
    itemId, 
    labelText,
    maxFilesCount,
    onSubmit
}) {
    const [maxLength, setMaxLength] = useState(null);
    const { register, handleSubmit } = useForm({
        defaultValues: {
            id: itemId,
            files: '',
        }
    });

    useEffect(() => {
       if(maxFilesCount) {
        setMaxLength(maxFilesCount);
       }
    }, [maxFilesCount]);

    const handleSubmitPhotos = async (data, e) => {
        e.preventDefault();

        if(maxLength) {
            if(data?.files?.length > maxLength) {
                toast.warning(`No se pueden subir más de ${maxLength} imágenes!!`);
                return;
            } else onSubmit(data);
        } else onSubmit(data);
    };

    return (
        <div className="w-100 d-flex flex-column justify-content-center">
            <div>
                <form className="form  mb-4" onSubmit={handleSubmit(handleSubmitPhotos)}>
                    <input 
                        type="hidden" 
                        {...register("id")} 
                        defaultValue={itemId} />

                    <div className="w-100 d-flex">
                        <div className="form-group">
                            <label htmlFor="files">{labelText}</label>
                            <input
                                type="file" 
                                multiple
                                className="form-control" 
                                {...register("files")} 
                                defaultValue={''} />
                        </div>
                    </div>

                    <div className="d-flex align-items-center align-self-end">
                        <button type="submit" className="btn btn-primary align-self-end">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}